import * as React from "react";
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Alert } from 'reactstrap';
import DropZoneField from '../Config/DropZone';
import api from "../Config/HttpFeasibility";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { Link } from "react-router-dom";
import es from 'date-fns/locale/es';
import { Field, reduxForm } from 'redux-form';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import moment from 'moment';

import Modal from '../../../../shared/components/Modal';

registerLocale('es', es)


const Confidentiality = ({ history, feasibility, toggleConfientialityMe }) => {
    const params = feasibility;

    const [comment, setComment] = React.useState(null);
    const [file, setFile] = React.useState(null);
    const [loading, setLoadin] = React.useState(false);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    const { t } = useTranslation('common');

    const Loading = () => (<div class="loading">
        <div class="load__icon-wrap">
            <svg class="load__icon">
                <path fill="#a244fa" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
        </div>
    </div>);

    const handleFocus = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const validateComment = () => {
        if (comment == null || comment.length < 1) {
            openModal(false, t('msg.comment_require'));
            return false;
        } else {
            return true;
        }
    }

    const validate = async () => {
        if (file != null) {
            var dataFile = new FormData();
            dataFile.append("archivo", file);
            dataFile.append("id_factibilidad", params.id_factibilidad);
            dataFile.append("observaciones", comment);
            sendRequest(dataFile);
        }
        else {
            openModal(false, t('msg.file_empty'));
        }
    }



    const sendRequest = async (_dataJson) => {
        try {
            //let url= process.env.REACT_APP_PUBLIC_URL;//PRUEBAS
            let url = process.env.REACT_APP_PUBLIC_URL;

            let usuario = JSON.parse(sessionStorage.getItem('usuario'));
            let date = moment(new Date()).format("YYYY/MM/DD");

            _dataJson.append("usuario", usuario.nombre);
            _dataJson.append("date", date);
            if (usuario.nombre != "") {
                fetch(url + 'factibilidad/subecontrato', {
                    method: 'POST',
                    headers: {
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    'Content-Type': 'application/json',
                    body: _dataJson
                }).then(response => response.json())
                    .then(data => {
                        toggleConfientialityMe(data.archivos);
                    }).catch(error => console.error(error));
            }
            else {
                openModal(false, "Ha ocurrido un error con el Usuario, por favor inicie sesión nuevamente");
            }
        }
        catch (e) {
            openModal(false, "Ha ocurrido un error en el sistema");
        }
    }

    return (<Container>
        <Row>
            <Col >
                <Card className="card--flex">
                    <CardBody className="width_static">
                        <form className="form form_vertical" >
                            <div className="form__form-group txt-area">
                                <span className="form__form-group-label">{t('confidentiality.comment')}</span>
                                <div className="form__form-group-field">
                                    <textarea id="txtComment" name="txtComment" onBlur={handleFocus} onFocus={handleFocus}
                                        onChange={({ target: { value } }) => setComment(value)}></textarea>
                                </div>
                            </div>

                            <div className="form__form-group">
                                {loading ?
                                    <Loading />
                                    :

                                    /**<Field value={files} onChange={setFiles} component={DropZoneField} /> */

                                    <input accept="application/pdf" id="confidentialityFile" name="confidentialityFile" type="file" onChange={(e) => { setFile(e.target.files[0]) }} />
                                }
                            </div>

                            <ButtonToolbar className="form__button-toolbar">
                                <Button color="primary" type="button"
                                    onClick={() => validate()}>
                                    {t('btn.upload')}</Button>
                            </ButtonToolbar>
                        </form>
                    </CardBody>
                </Card>
            </Col>

            <Modal
                color={colorModal}
                title={messageModal}
                modal={showModal}
                onOk={() => setShowModal(false)}
                toggle={() => setShowModal(false)}
            />
        </Row>
    </Container>);
}

export default reduxForm({
    form: 'confidentiality_form', // a unique identifier for this form
})(Confidentiality);